import * as React from 'react';
import { Component } from 'react';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import TimeRangeFilter from '../../TimeRangeFilter';
import AssessmentIcon from '@mui/icons-material/Assessment';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface ITimeRangeChipProps {
    filterNames: string[],
    onSelect: (filterName: string, value: any) => void,
    unmarkNamedFilterAsApplier: (filterName: string) => void,
    title: string,
    currentStart: any,
    currentEnd: any,
    show: boolean,
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    showOnReport?: boolean;
}

interface ITimeRangeChipState {
    applied: boolean;
}


class TimeRangeChip extends Component<ITimeRangeChipProps, ITimeRangeChipState> {
    constructor(props) {
        super(props);

        this.state = {
            applied: false,
        }
    }

    public handleSelect = (name: any, value: any) => {
        this.props.onSelect(name, value);
    }


    public render() {
        const classes = styles;
        const showRemove = this.props.removeFilter !== null && this.props.removeFilter !== undefined ?
            <IconButton title="Remove" aria-label="Remove" onClick={this.handleDelete} sx={classes.button}><CancelIcon /></IconButton> : <React.Fragment />;

        return (
            <React.Fragment>
                {this.props.show
                    ?
                    <Grid>
                        <Grid container sx={classes.root} justifyContent="space-between" alignItems="center">
                            {this.props.showOnReport &&
                                <AssessmentIcon sx={{ ml: 1 }} />
                            }
                            <Grid sx={classes.text}>
                                <Typography variant="body1">{this.props.title}</Typography>
                            </Grid>
                            <TimeRangeFilter filterNames={this.props.filterNames} startValue={this.props.currentStart} endValue={this.props.currentEnd} setFilterValue={this.handleSelect} applied={this.state.applied} unmarkApplied={this.unmarkNamedFilterAsApplier} displayName={this.props.title} />
                            <Grid>
                                {showRemove}
                            </Grid>
                        </Grid>
                    </Grid>
                    :
                    <React.Fragment />
                }
            </React.Fragment>)
    }


    private unmarkNamedFilterAsApplier = (value: any) => {
        this.props.unmarkNamedFilterAsApplier(value);
    }

    private handleDelete = () => {
        if (this.props.removeFilter !== null && this.props.removeFilter !== undefined) {
            this.props.removeFilter(this.props.filterFlag, this.props.filterNames);
        }
    }
}
export default TimeRangeChip;